import useAuth from "app/hooks/useAuth";
import { set } from "lodash";
import moment from "moment";
import React, { useState } from "react";

export const TitleContext = React.createContext();

export const TitleProvider = ({ children }) => {

  const { user } = useAuth();

  // Defines hooks
  const [title, setTitle] = useState("Dashboard");
  const [page, setPage] = useState("Dashboard");
  const [path, setPath] = useState("/Dashboarddashboard/default");
  const [action, setAction] = useState("List");
  const [module, setModule] = useState("dashboard");
  const [drawer, setDrawer] = useState(false);

  const [blockDisplay, setBlockDisplay] = useState(false);
  const [clusterDisplay, setClusterDisplay] = useState(false);
  const [schoolDisplay, setSchoolDisplay] = useState(false);



  const [schoolblockDisplay, setSchoolBlockDisplay] = useState(false);
  const [schoolclusterDisplay, setSchoolClusterDisplay] = useState(false);
  const [schoolsideDisplay, setSchoolSideDisplay] = useState(false);

  const [summaryblockDisplay, setSummaryBlockDisplay] = useState(false);
  const [summaryclusterDisplay, setSummaryClusterDisplay] = useState(false);
  const [summaryschoolDisplay, setSummarySchoolDisplay] = useState(false);


  const [studentTargetblockDisplay, setstudentTargetBlockDisplay] = useState(false);
  const [studentTargetclusterDisplay, setstudentTargetClusterDisplay] = useState(false);
  const [studentTargetschoolDisplay, setstudentTargetSchoolDisplay] = useState(false);


  const [studentTargetfiltertype, setstudentTargetfiltertype] = useState();
  const [studentTargetfiltercode, setstudentTargetfiltercode] = useState();


  const [summaryfiltertype, setSummaryfiltertype] = useState();
  const [summaryfiltercode, setSummaryfiltercode] = useState();

  const [schoolfiltertype, setSchoolfiltertype] = useState();
  const [schoolfiltercode, setSchoolfiltercode] = useState();

  const [schoolSumaryfiltertype, setSchoolSumaryfiltertype] = useState();
  const [schoolSumaryfiltercode, setSchoolSumaryfiltercode] = useState();

  const [schoolSummaryblockDisplay, setSchoolSummaryBlockDisplay] = useState(false);
  const [schoolSummaryclusterDisplay, setSchoolSummaryClusterDisplay] = useState(false);
  const [schoolSummaryschoolDisplay, setSchoolSummarySchoolDisplay] = useState(false);

  const [smcblockDisplay, setSmcBlockDisplay] = useState(false);
  const [smcclusterDisplay, setSmcClusterDisplay] = useState(false);
  const [smcschoolDisplay, setSmcSchoolDisplay] = useState(false);

  const [smcfiltertype, setSmcfiltertype] = useState();
  const [smcfiltercode, setSmcfiltercode] = useState();

  const [commissionblockDisplay, setCommissionBlockDisplay] = useState(false);
  const [commissionclusterDisplay, setCommissionClusterDisplay] = useState(false);
  const [commissionschoolDisplay, setCommissionSchoolDisplay] = useState(false);

  const [commissionfiltertype, setCommissionfiltertype] = useState();
  const [commissionfiltercode, setCommissionfiltercode] = useState();

  const [attendanceblockDisplay, setAttendanceBlockDisplay] = useState(false);
  const [attendanceclusterDisplay, setAttendanceClusterDisplay] = useState(false);
  const [attendanceschoolDisplay, setAttendanceSchoolDisplay] = useState(false);

  const [attendancefiltertype, setAttendancefiltertype] = useState();
  const [attendancefiltercode, setAttendancefiltercode] = useState();

  const [castblockDisplay, setCastBlockDisplay] = useState(false);
  const [castclusterDisplay, setCastClusterDisplay] = useState(false);
  const [castschoolDisplay, setCastSchoolDisplay] = useState(false);

  const [castfiltertype, setCastfiltertype] = useState();
  const [castfiltercode, setCastfiltercode] = useState();

  const [classblockDisplay, setClassBlockDisplay] = useState(false);
  const [classclusterDisplay, setClassClusterDisplay] = useState(false);
  const [classschoolDisplay, setClassSchoolDisplay] = useState(false);

  const [classfiltertype, setClassfiltertype] = useState();
  const [classfiltercode, setClassfiltercode] = useState();

  const [marquee, setMarquee] = useState("");
  const [ColorCode, setColorCode] = useState(localStorage.getItem("ColorCode"));
  const [reportTabStatus, setReportTabStatus] = useState('1');

  const [academic, setAcademic] = useState();
  const [resetStatus, setResetStatus] = useState(false);

  const [districtValue, setDistrictValue] = useState({ district_id: '', name: '' });
  const [blockValue, setBlockValue] = useState({ block_id: '', name: '' });
  const [clusterValue, setClusterValue] = useState({ cluster_id: '', name: '' });
  const [schoolValue, setSchoolValue] = useState({ school_id: '', name: '' });

  const [traccarDriverId, setTraccarDriverId] = useState("")
  const [dashboardDate, setDashboardDate] = useState()

  const [badgeContent, setBadgeContent] = useState('');

  const [selectemonth, setSelecteMonth] = useState('');

  const [academicYear, setAcademicYear] = useState([]);
  const [overspeedYearOfAcademic, setOverspeedYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [sosYearOfAcademic, setSosYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [castYearOfAcademic, setCastYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [commisssionYearOfAcademic, setCommisssionYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [classYearOfAcademic, setClassYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [dailyYearOfAcademic, setDailyYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [monthlyYearOfAcademic, setMonthlyYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [totalYearOfAcademic, setTotalYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [primaryYearOfAcademic, setPrimaryYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [secondaryYearOfAcademic, setSecondaryYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [schoolWithYearOfAcademic, setSchoolWithYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [vehicleYearOfAcademic, setVehicleYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [notificationYearOfAcademic, setNotificationYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [beneficiaryYearOfAcademic, setBenificiaryYearOfAcademic] = useState([{ lable: '', value: '' }]);
  const [dashboardYearOfAcademic, setDashboardYearOfAcademic] = useState([{ lable: '', value: '' }]);

  const [districtAttendanceChart, setDistrictAttendanceChart] = useState('');
  const [blockAttendanceChart, setBlockAttendanceChart] = useState('');
  const [clusterAttendanceChart, setClusterAttendanceChart] = useState('');
  const [schoolAttendanceChart, setSchoolAttendanceChart] = useState('');
  const [xTitleAttendance, setXTitleAttendance] = useState('');
  const [districtAttendanceChartCode, setDistrictAttendanceChartCode] = useState('');
  const [blockAttendanceChartCode, setBlockAttendanceChartCode] = useState('');
  const [clusterAttendanceChartCode, setClusterAttendanceChartCode] = useState('');

  const [attendanceFilterType, setAttendanceFilterType] = useState();
  const [attendanceFilterName, setAttendanceFilterName] = useState();

  const [selectedComponents, setSelectedComponents] = useState({ label: "Daily Attendance Report", value: "DailyAttendanceReport" });

  if (user && user.resource_access["react-app"].roles[0] !== "school") {
    setSelectedComponents({ label: "Daily Report", value: "DailyReport" })
  }
  const [studentColor, setStudentColor] = useState('#198DCB');

  const [primaryBlockDisplay, setPrimaryBlockDisplay] = useState(false);
  const [primaryClusterDisplay, setPrimaryClusterDisplay] = useState(false);
  const [primarySchoolDisplay, setPrimarySchoolDisplay] = useState(false);
  const [primaryfiltertype, setPrimaryfiltertype] = useState();
  const [primaryfiltercode, setPrimaryfiltercode] = useState();
  const [selectedDriver, setSelectedDriver] = useState([]);
  const [schoolId, setSchoolId] = useState(null);

  const [vehicleblockDisplay, setVehicleBlockDisplay] = useState(false);
  const [vehicleclusterDisplay, setVehicleClusterDisplay] = useState(false);
  const [vehicleschoolDisplay, setVehicleSchoolDisplay] = useState(false);
  const [vehiclefiltertype, setVehiclefiltertype] = useState();
  const [vehiclefiltercode, setVehiclefiltercode] = useState();

  const [dailyAttendanceblockDisplay, setDailyAttendanceBlockDisplay] = useState(false);
  const [dailyAttendanceclusterDisplay, setDailyAttendanceClusterDisplay] = useState(false);
  const [dailyAttendanceschoolDisplay, setDailyAttendanceSchoolDisplay] = useState(false);
  const [dailyAttendancefiltertype, setDailyAttendancefiltertype] = useState();
  const [dailyAttendancefiltercode, setDailyAttendancefiltercode] = useState();

  const [dailyblockDisplay, setDailyBlockDisplay] = useState(false);
  const [dailyclusterDisplay, setDailyClusterDisplay] = useState(false);
  const [dailyschoolDisplay, setDailySchoolDisplay] = useState(false);

  const [dailyfiltertype, setDailyfiltertype] = useState();
  const [dailyfiltercode, setDailyfiltercode] = useState();

  const [studentdailyBlockDisplay, setStudentDailyBlockDisplay] = useState(false);
  const [studentdailyClusterDisplay, setStudentDailyClusterDisplay] = useState(false);
  const [studentdailySchoolDisplay, setStudentDailySchoolDisplay] = useState(false);
  const [studentdailyfiltertype, setStudentDailyfiltertype] = useState();
  const [studentdailyfiltercode, setStudentDailyfiltercode] = useState();
  const [studentdailyDriverDisplay, setStudentDailyDriverDisplay] = useState(false);

  const [attendanceDate, setAttendanceDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [districtDriverAttendanceChart, setDistricDrivertAttendanceChart] = useState('');
  const [blockDriverAttendanceChart, setBlockDriverAttendanceChart] = useState('');
  const [clusterDriverAttendanceChart, setClusterDriverAttendanceChart] = useState('');
  const [schoolDriverAttendanceChart, setSchoolDriverAttendanceChart] = useState('');
  const [driverAttendanceFilterType, setDriverAttendanceFilterType] = useState();
  const [driverAttendanceFilterName, setDriverAttendanceFilterName] = useState();
  const [districtDriverAttendanceChartCode, setDistricDrivertAttendanceChartCode] = useState('');
  const [blockDriverAttendanceChartCode, setBlockDriverAttendanceChartCode] = useState('');
  const [clusterDriverAttendanceChartCode, setClusterDriverAttendanceChartCode] = useState('');

  const [selectTransmonth, setSelectTransMonth] = useState('');

  const [driverOnline, setdriverOnline] = useState([])
  const [showSchoolMarkers, setShowShcoolsMarkers] = useState(false)


  const [overspeedBlockDisplay, setOverspeedBlockDisplay] = useState(false);
  const [overspeedClusterDisplay, setOverspeedClusterDisplay] = useState(false);
  const [overspeedSchoolDisplay, setOverspeedSchoolDisplay] = useState(false);
  const [overspeedDriverDisplay, setOverspeedDriverDisplay] = useState(false);
  const [overspeedfiltertype, setOverspeedfiltertype] = useState();
  const [overspeedfiltercode, setOverspeedfiltercode] = useState();

  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const [overspeedFromDate, setOverspeedFromDate] = useState(startOfMonth);
  const [overspeedToDate, setOverspeedToDate] = useState(endOfMonth);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  let defaultDateValue = new Date().toISOString().split("T")[0];
  const [currentAttendenceDate, setCurrentAttendenceDate] = useState(defaultDateValue);

  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is 0-indexed

  // Determine academic year based on month
  const academicYearStart = month >= 5 ? year : year - 1;
  const academicYearEnd = academicYearStart + 1;
  const academicYearAttendence = `${academicYearStart}_${academicYearEnd.toString().substring(2)}`;

  const [attendenceAcademicYear, setAttendenceAcademicYear] = useState(academicYearAttendence);
  const [tabIndexImportSchool, setTabIndexImportSchool] = useState(1);

  return (
    <TitleContext.Provider
      value={{
        title,
        setTitle,
        reportTabStatus,
        setReportTabStatus,
        page,
        setPage,
        ColorCode,
        setColorCode,
        blockDisplay,
        setBlockDisplay,
        clusterDisplay,
        setClusterDisplay,
        schoolDisplay,
        setSchoolDisplay,
        path,
        setPath,
        action,
        setAction,
        module,
        setModule,
        drawer,
        setDrawer,
        marquee,
        setMarquee,

        districtValue,
        setDistrictValue,
        blockValue,
        setBlockValue,
        clusterValue,
        setClusterValue,
        schoolValue,
        setSchoolValue,

        schoolblockDisplay,
        setSchoolBlockDisplay,
        schoolclusterDisplay,
        setSchoolClusterDisplay,
        schoolsideDisplay,
        setSchoolSideDisplay,

        schoolfiltertype,
        schoolfiltercode,
        setSchoolfiltertype,
        setSchoolfiltercode,

        smcblockDisplay,
        setSmcBlockDisplay,
        smcclusterDisplay,
        setSmcClusterDisplay,
        smcschoolDisplay,
        setSmcSchoolDisplay,

        smcfiltertype,
        smcfiltercode,
        setSmcfiltertype,
        setSmcfiltercode,

        commissionblockDisplay,
        setCommissionBlockDisplay,
        commissionclusterDisplay,
        setCommissionClusterDisplay,
        commissionschoolDisplay,
        setCommissionSchoolDisplay,

        commissionfiltertype,
        setCommissionfiltertype,
        commissionfiltercode,
        setCommissionfiltercode,

        attendanceblockDisplay,
        setAttendanceBlockDisplay,
        attendanceclusterDisplay,
        setAttendanceClusterDisplay,
        attendanceschoolDisplay,
        setAttendanceSchoolDisplay,

        attendancefiltertype,
        attendancefiltercode,
        setAttendancefiltertype,
        setAttendancefiltercode,

        traccarDriverId,
        setTraccarDriverId,

        academic,
        setAcademic,

        dashboardDate,
        setDashboardDate,

        resetStatus,
        setResetStatus,

        castblockDisplay,
        setCastBlockDisplay,
        castclusterDisplay,
        setCastClusterDisplay,
        castschoolDisplay,
        setCastSchoolDisplay,

        castfiltertype,
        setCastfiltertype,
        castfiltercode,
        setCastfiltercode,

        classblockDisplay,
        setClassBlockDisplay,
        classclusterDisplay,
        setClassClusterDisplay,
        classschoolDisplay,
        setClassSchoolDisplay,

        classfiltertype,
        setClassfiltertype,
        classfiltercode,
        setClassfiltercode,

        badgeContent,
        setBadgeContent,

        selectemonth,
        setSelecteMonth,

        academicYear,
        setAcademicYear,
        overspeedYearOfAcademic,
        setOverspeedYearOfAcademic,
        sosYearOfAcademic,
        setSosYearOfAcademic,
        castYearOfAcademic,
        setCastYearOfAcademic,
        commisssionYearOfAcademic,
        setCommisssionYearOfAcademic,
        classYearOfAcademic,
        setClassYearOfAcademic,
        dailyYearOfAcademic,
        setDailyYearOfAcademic,
        monthlyYearOfAcademic,
        setMonthlyYearOfAcademic,
        totalYearOfAcademic,
        setTotalYearOfAcademic,
        primaryYearOfAcademic,
        setPrimaryYearOfAcademic,
        secondaryYearOfAcademic,
        setSecondaryYearOfAcademic,
        schoolWithYearOfAcademic,
        setSchoolWithYearOfAcademic,
        vehicleYearOfAcademic,
        setVehicleYearOfAcademic,
        notificationYearOfAcademic,
        setNotificationYearOfAcademic,
        beneficiaryYearOfAcademic,
        setBenificiaryYearOfAcademic,
        dashboardYearOfAcademic,
        setDashboardYearOfAcademic,

        districtAttendanceChart,
        setDistrictAttendanceChart,
        blockAttendanceChart,
        setBlockAttendanceChart,
        clusterAttendanceChart,
        setClusterAttendanceChart,
        schoolAttendanceChart,
        setSchoolAttendanceChart,
        xTitleAttendance,
        setXTitleAttendance,

        selectedComponents,
        setSelectedComponents,

        attendanceFilterType,
        setAttendanceFilterType,
        attendanceFilterName,
        setAttendanceFilterName,

        studentColor,
        setStudentColor,

        summaryblockDisplay,
        setSummaryBlockDisplay,
        summaryclusterDisplay,
        setSummaryClusterDisplay,
        summaryschoolDisplay,
        setSummarySchoolDisplay,

        summaryfiltertype,
        setSummaryfiltertype,
        summaryfiltercode,
        setSummaryfiltercode,

        schoolSumaryfiltertype,
        setSchoolSumaryfiltertype,
        schoolSumaryfiltercode,
        setSchoolSumaryfiltercode,

        schoolSummaryblockDisplay,
        setSchoolSummaryBlockDisplay,
        schoolSummaryclusterDisplay,
        setSchoolSummaryClusterDisplay,
        schoolSummaryschoolDisplay,
        setSchoolSummarySchoolDisplay,

        studentTargetblockDisplay,
        setstudentTargetBlockDisplay,
        studentTargetclusterDisplay,
        setstudentTargetClusterDisplay,
        studentTargetschoolDisplay,
        setstudentTargetSchoolDisplay,

        studentTargetfiltertype,
        setstudentTargetfiltertype,
        studentTargetfiltercode,
        setstudentTargetfiltercode,

        primaryBlockDisplay,
        setPrimaryBlockDisplay,
        primaryClusterDisplay,
        setPrimaryClusterDisplay,
        primarySchoolDisplay,
        setPrimarySchoolDisplay,
        primaryfiltertype,
        setPrimaryfiltertype,
        primaryfiltercode,
        setPrimaryfiltercode,

        selectedDriver,
        setSelectedDriver,

        schoolId, setSchoolId,

        vehicleblockDisplay,
        setVehicleBlockDisplay,
        vehicleclusterDisplay,
        setVehicleClusterDisplay,
        vehicleschoolDisplay,
        setVehicleSchoolDisplay,
        vehiclefiltertype,
        setVehiclefiltertype,
        vehiclefiltercode,
        setVehiclefiltercode,

        dailyAttendanceblockDisplay,
        setDailyAttendanceBlockDisplay,
        dailyAttendanceclusterDisplay,
        setDailyAttendanceClusterDisplay,
        dailyAttendanceschoolDisplay,
        setDailyAttendanceSchoolDisplay,

        dailyAttendancefiltertype,
        setDailyAttendancefiltertype,
        dailyAttendancefiltercode,
        setDailyAttendancefiltercode,

        dailyblockDisplay,
        setDailyBlockDisplay,
        dailyclusterDisplay,
        setDailyClusterDisplay,
        dailyschoolDisplay,
        setDailySchoolDisplay,

        dailyfiltertype,
        setDailyfiltertype,
        dailyfiltercode,
        setDailyfiltercode,

        attendanceDate,
        setAttendanceDate,

        districtDriverAttendanceChart,
        setDistricDrivertAttendanceChart,
        blockDriverAttendanceChart,
        setBlockDriverAttendanceChart,
        clusterDriverAttendanceChart,
        setClusterDriverAttendanceChart,
        schoolDriverAttendanceChart,
        setSchoolDriverAttendanceChart,
        driverAttendanceFilterType,
        setDriverAttendanceFilterType,
        driverAttendanceFilterName,
        setDriverAttendanceFilterName,

        selectTransmonth,
        setSelectTransMonth,

        studentdailyBlockDisplay,
        setStudentDailyBlockDisplay,
        studentdailyClusterDisplay,
        setStudentDailyClusterDisplay,
        studentdailySchoolDisplay,
        setStudentDailySchoolDisplay,
        studentdailyfiltertype,
        setStudentDailyfiltertype,
        studentdailyfiltercode,
        setStudentDailyfiltercode,
        studentdailyDriverDisplay,
        setStudentDailyDriverDisplay,

        districtAttendanceChartCode,
        setDistrictAttendanceChartCode,
        blockAttendanceChartCode,
        setBlockAttendanceChartCode,
        clusterAttendanceChartCode,
        setClusterAttendanceChartCode,

        districtDriverAttendanceChartCode,
        setDistricDrivertAttendanceChartCode,
        blockDriverAttendanceChartCode,
        setBlockDriverAttendanceChartCode,
        clusterDriverAttendanceChartCode,
        setClusterDriverAttendanceChartCode,

        driverOnline,
        setdriverOnline,
        showSchoolMarkers, setShowShcoolsMarkers,

        overspeedBlockDisplay, setOverspeedBlockDisplay,
        overspeedClusterDisplay, setOverspeedClusterDisplay,
        overspeedSchoolDisplay, setOverspeedSchoolDisplay,
        overspeedDriverDisplay, setOverspeedDriverDisplay,
        overspeedfiltertype, setOverspeedfiltertype,
        overspeedfiltercode, setOverspeedfiltercode,
        overspeedFromDate, setOverspeedFromDate,
        overspeedToDate, setOverspeedToDate,

        fromDate,
        setFromDate,
        toDate,
        setToDate,
        attendenceAcademicYear,
        setAttendenceAcademicYear,

        currentAttendenceDate,
        setCurrentAttendenceDate,
        tabIndexImportSchool, setTabIndexImportSchool
      }}
    >
      {children}
    </TitleContext.Provider>
  );
};

export default TitleProvider;
